// extracted by mini-css-extract-plugin
module.exports = {"container":"BestWayToWakeUp_container__Xu2FJ","inner_container":"BestWayToWakeUp_inner_container__R2PBa","video_container":"BestWayToWakeUp_video_container__4kco_"};